export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/905332836679"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg transition-all hover:scale-110 cursor-pointer"
      aria-label="WhatsApp ile iletişime geç"
    >
      <i className="ri-whatsapp-line text-2xl" />
    </a>
  );
}
